module.exports = __webpack_public_path__ + "img/icon_muyu_logo.e348d447.png";